/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import { getTranslatedExtensions } from 'utils/translate';

class TranslatableAsyncObject {
  constructor(object) {
    this._json = object.json();
  }

  name() {
    return getTranslatedExtensions(this._json, 'name');
  }

  title() {
    return getTranslatedExtensions(this._json, 'title');
  }

  summary() {
    return getTranslatedExtensions(this._json, 'summary');
  }

  description() {
    return getTranslatedExtensions(this._json, 'description');
  }
}

export default TranslatableAsyncObject;
